// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.validateReplacementModal_titleRow__q2Bj0 {
    margin-top: 23px;
    padding-left: 25px;
    align-items: center;
}

.validateReplacementModal_replacementRowTop__6hxBN {
    margin-top: 20px;
    margin-left: 0px !important;
}

.validateReplacementModal_replacementRowOther__zNyMx {
    margin-top: 5px;
    margin-left: 0px !important;
}

.validateReplacementModal_titleLabel__-d\\+jd {
    top: 323px;
    left: 93px;
    width: 190px;
    height: 18px;
    text-align: center;
    font-size: 15px;
    line-height: 19px;
    font-weight: bold;
    letter-spacing: 0px;
    color: #65686B;
    opacity: 1;
}
/*mobile*/
@media only screen and (max-width: 768px) {
    .validateReplacementModal_materialLabel__IChLa {
        font-size: 14px;
    }
    
}

/*desktop*/
@media only screen and (min-width: 768px) {
    .validateReplacementModal_materialLabel__IChLa {
        font-size: 16px;
    }
    
}

.validateReplacementModal_validationsLabel__JPQhf {
    font-size: 14px;
}

.validateReplacementModal_notPassedRow__br3xl {
    margin-top: 10px;
}

.validateReplacementModal_notPassed__F2gsB {
    font-size: 14px;
    color: #a0a0a0;
}

.validateReplacementModal_buttonRow__b0CTL {
    margin-top: 15px;
    margin-bottom: 15px;
    padding-left: 20px;
}

.validateReplacementModal_editButtonRow__rHXNh {
    margin-top: 15px;
    margin-bottom: 15px;
}

.validateReplacementModal_editButton__psXtt {
    background-color: #65686B;
    border-radius: 10px;
    border: 1px solid;
    color: white;
    font-size: 16px;
    font-weight: 350;
    padding: 5px 10px;
}

.validateReplacementModal_continueButton__sEa4\\+ {
    background-color: #14C232;
    border-radius: 10px;
    border: 1px solid;
    color: white;
    font-size: 16px;
    font-weight: 350;
    padding: 5px 10px;
}

.validateReplacementModal_disabledButton__mjifi {
    background-color: #fff;
    border-radius: 10px;
    border: 1px solid;
    color: #65686B;
    font-size: 16px;
    font-weight: 350;
    padding: 5px 10px;
}`, "",{"version":3,"sources":["webpack://./src/components/validateReplacementModal/validateReplacementModal.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,mBAAmB;IACnB,cAAc;IACd,UAAU;AACd;AACA,SAAS;AACT;IACI;QACI,eAAe;IACnB;;AAEJ;;AAEA,UAAU;AACV;IACI;QACI,eAAe;IACnB;;AAEJ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,sBAAsB;IACtB,mBAAmB;IACnB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB","sourcesContent":[".titleRow {\n    margin-top: 23px;\n    padding-left: 25px;\n    align-items: center;\n}\n\n.replacementRowTop {\n    margin-top: 20px;\n    margin-left: 0px !important;\n}\n\n.replacementRowOther {\n    margin-top: 5px;\n    margin-left: 0px !important;\n}\n\n.titleLabel {\n    top: 323px;\n    left: 93px;\n    width: 190px;\n    height: 18px;\n    text-align: center;\n    font-size: 15px;\n    line-height: 19px;\n    font-weight: bold;\n    letter-spacing: 0px;\n    color: #65686B;\n    opacity: 1;\n}\n/*mobile*/\n@media only screen and (max-width: 768px) {\n    .materialLabel {\n        font-size: 14px;\n    }\n    \n}\n\n/*desktop*/\n@media only screen and (min-width: 768px) {\n    .materialLabel {\n        font-size: 16px;\n    }\n    \n}\n\n.validationsLabel {\n    font-size: 14px;\n}\n\n.notPassedRow {\n    margin-top: 10px;\n}\n\n.notPassed {\n    font-size: 14px;\n    color: #a0a0a0;\n}\n\n.buttonRow {\n    margin-top: 15px;\n    margin-bottom: 15px;\n    padding-left: 20px;\n}\n\n.editButtonRow {\n    margin-top: 15px;\n    margin-bottom: 15px;\n}\n\n.editButton {\n    background-color: #65686B;\n    border-radius: 10px;\n    border: 1px solid;\n    color: white;\n    font-size: 16px;\n    font-weight: 350;\n    padding: 5px 10px;\n}\n\n.continueButton {\n    background-color: #14C232;\n    border-radius: 10px;\n    border: 1px solid;\n    color: white;\n    font-size: 16px;\n    font-weight: 350;\n    padding: 5px 10px;\n}\n\n.disabledButton {\n    background-color: #fff;\n    border-radius: 10px;\n    border: 1px solid;\n    color: #65686B;\n    font-size: 16px;\n    font-weight: 350;\n    padding: 5px 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"titleRow": `validateReplacementModal_titleRow__q2Bj0`,
	"replacementRowTop": `validateReplacementModal_replacementRowTop__6hxBN`,
	"replacementRowOther": `validateReplacementModal_replacementRowOther__zNyMx`,
	"titleLabel": `validateReplacementModal_titleLabel__-d+jd`,
	"materialLabel": `validateReplacementModal_materialLabel__IChLa`,
	"validationsLabel": `validateReplacementModal_validationsLabel__JPQhf`,
	"notPassedRow": `validateReplacementModal_notPassedRow__br3xl`,
	"notPassed": `validateReplacementModal_notPassed__F2gsB`,
	"buttonRow": `validateReplacementModal_buttonRow__b0CTL`,
	"editButtonRow": `validateReplacementModal_editButtonRow__rHXNh`,
	"editButton": `validateReplacementModal_editButton__psXtt`,
	"continueButton": `validateReplacementModal_continueButton__sEa4+`,
	"disabledButton": `validateReplacementModal_disabledButton__mjifi`
};
export default ___CSS_LOADER_EXPORT___;
